<template>
  <div class="wrapper">
    <NavSidebar>
      <template v-if="loggedIn && hasProfile" slot="links">
        <!-- <NavSidebarLink to="/dashboard" name="Dashboard" icon="columns" /> -->
        <!-- <NavSidebarLink to="/browse" name="Browse" icon="sitemap" />
        <NavSidebarLink to="/people" name="People" icon="users" />
        <NavSidebarLink to="/tenant" name="Tenant" icon="crown" /> -->
        <NavSidebarLink
          v-for="nav in navigationMain"
          :key="slugifyKey(nav.text)"
          :has-access="isChiRhosOwner || isTenantOwner || isTenantAdmin"
          :to="nav.target"
          :name="nav.text"
          :icon="nav.icon"
        />
      </template>
      <NavMobileMenu>
        <!-- <li class="nav-item">
          <a class="nav-link">
            <i class="ti-panel"></i>
            <p>Stats</p>
          </a>
        </li>
        <drop-down class="nav-item"
                   title="5 Notifications"
                   title-classes="nav-link"
                   icon="ti-bell">
          <a class="dropdown-item">Notification 1</a>
          <a class="dropdown-item">Notification 2</a>
          <a class="dropdown-item">Notification 3</a>
          <a class="dropdown-item">Notification 4</a>
          <a class="dropdown-item">Another notification</a>
        </drop-down> -->
        <NavSidebarLink
          v-if="loggedIn"
          to="/profile"
          name="Profile"
          icon="user"
        />
        <NavSidebarLink
          v-if="loggedIn"
          to="/notifications"
          name="Notifications"
          icon="bell"
        />
        <NavSidebarLink to="/settings" name="Settings" icon="cog" />
        <NavSidebarLink to="/logout" name="Log Out" icon="sign-out-alt" />
        <!-- <li class="nav-item">
          <a
            class="nav-link"
            href="logout"
          >
            <i class="fas fa-sign-out-alt sign-out-alt" />
            <p>Log out</p>
          </a>
        </li> -->
        <li class="divider" />
      </NavMobileMenu>
    </NavSidebar>
    <div class="main-panel">
      <NavTopBar />
      <MainContent @click.native="toggleSidebar" />
      <NavFooter />
    </div>
  </div>
</template>

<script>
// import Notify from 'vue-notifyjs'
import { PaladinCoreUtils, PaladinCoreStateHelpers } from '@paladin/core'
import { AuthHelpers } from '@paladin/core-auth'
import * as PaladinCoreUIStateHelpers from '../../state/helpers'
import NavTopBar from '../../components/navigation/nav-topbar'
import NavSidebar from '../../components/navigation/nav-sidebar'
import NavSidebarLink from '../../components/navigation/nav-sidebar-link'
import NavMobileMenu from '../../components/navigation/nav-mobile-menu'
import MainContent from '../../components/content'
import NavFooter from '../../components/navigation/nav-footer'

export default {
  components: {
    NavTopBar,
    NavSidebar,
    NavSidebarLink,
    NavMobileMenu,
    MainContent,
    NavFooter,
  },
  computed: {
    ...AuthHelpers.authComputed,
    ...PaladinCoreUIStateHelpers.layoutComputed,
    ...PaladinCoreStateHelpers.userComputed,
  },
  mounted() {
    // console.log(this.user)
    // console.log(this.navigationMain)
  },
  methods: {
    toggleSidebar() {
      if (this.$store.state.layout.showSidebar) {
        this.$store.dispatch('layout/displaySidebar', false)
      }
    },
    slugifyKey(text) {
      return PaladinCoreUtils.slugify(text, '-')
    },
  },
}
</script>
